export default __webpack_public_path__ + "static/media/commented.e58be500.svg";